<template>
  <a
    :href="link"
    target="_blank"
    class="text-neutral-40 hover:bg-neutral-90 flex flex-col space-y-2 rounded-lg px-5 py-5 text-left"
  >
    <div class="flex items-center space-x-2">
      <SimpleBadge v-if="tag" square theme="neutral-border">{{ tag ?? t("event") }}</SimpleBadge>
      <p class="text-neutral-40 truncate text-xs font-normal">{{ date }}</p>
    </div>
    <span class="text-neutral-0 text-sm font-medium"> {{ title }} </span>
  </a>
</template>

<script lang="ts" setup>
// Components
import SimpleBadge from "@atoms/SimpleBadge/SimpleBadge.vue";

// I18n
import { useI18n } from "vue-i18n";

const { t } = useI18n();

withDefaults(
  defineProps<{
    title: string;
    date: DateString;
    link: UrlString;
    tag?: string;
  }>(),
  {},
);
</script>
<i18n lang="jsonc">
{
  "es": {
    "event": "Evento",
  },
  "pt": {
    "event": "Evento",
  },
}
</i18n>
